import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContentHeader, Divider } from '_template';
import Breadcrumbs from 'components/Breadcrumbs';
import Actions from './components/Actions';
import UserTable from './components/UserTable';
import LimitedAccess from 'components/LimitedAccess';
import { RIGHTS } from 'constants/rights';
import Helmet from 'components/Helmet';

const UserList = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet title={t<string>('USER.MODEL_TITLE')} />
      <ContentHeader
        title={t('USER.MODEL_TITLE')}
        actions={<Actions />}
        breadcrumbs={<Breadcrumbs section={t('USER.MODEL_TITLE')} />}
      />
      <Divider sx={{ my: 4 }} />
      <LimitedAccess right={RIGHTS.USER.LIST}>
        <UserTable />
      </LimitedAccess>
    </>
  );
};

export default UserList;
